/**
 * Created by Rodrigo Quesada on 24/05/17.
 */
import {NgModule} from '@angular/core';
import {CookieTokenStoreManager, StormpathModule as OriginalStormpathModule} from 'angular-stormpath';

@NgModule({
    imports: [OriginalStormpathModule],
    exports: [OriginalStormpathModule],
    providers: [{provide: 'tokenStore', useClass: CookieTokenStoreManager}]
})
export class StormpathModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/infrastructure/security/stormpath/stormpath.module.ts